import { render, staticRenderFns } from "./orderPayment.vue?vue&type=template&id=54bdf658&scoped=true"
import script from "./orderPayment.vue?vue&type=script&lang=js"
export * from "./orderPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bdf658",
  null
  
)

export default component.exports